export const isToday = (isoLike: string): boolean => {
  const ymd = (isoLike || '').trim().slice(0, 10);
  const now = new Date();
  const yyyy = String(now.getFullYear()).padStart(4, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return ymd === `${yyyy}-${mm}-${dd}`;
};

export const parseDateISO = (dateStr?: string): Date | null => {
  if (!dateStr) {
    return null;
  }
  const normalized =
    dateStr.includes(' ') && !dateStr.includes('T')
      ? dateStr.replace(' ', 'T')
      : dateStr;
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const todayLocalISO = (): string => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const normalize = (s?: string) =>
  String(s || '')
    .trim()
    .toLowerCase();

export const fmtTime = (iso: string, tz?: string): string => {
  try {
    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: tz || undefined,
    }).format(new Date(iso));
  } catch {
    return new Date(iso).toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
    });
  }
};
